import { Badge } from '@/components/ui/badge'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { ProcessorDetails } from '@/lib/api/processors'
import { ProcessorHeader } from '../components/processor-header'
import { ProcessorOverviewCard } from '../components/processor-overview-card'
import { ProcessorMetricsCard } from '../components/processor-metrics-card'
import { ProcessorPaymentMethodsCard } from '../components/processor-payment-methods-card'

interface MollieProcessorDetailsPageProps {
    processor: ProcessorDetails
}

const MollieConfigurationCard = ({ processor }: MollieProcessorDetailsPageProps) => {
    const options = processor.options as Record<string, any> | null
    const isTestKey = options?.apiKey?.startsWith('test_')

    return (
        <Card className="mb-6">
            <CardHeader><CardTitle>Mollie Configuration</CardTitle></CardHeader>
            <CardContent>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <p className="text-sm text-muted-foreground">API Key</p>
                        <p className="font-mono text-sm">••••••••••••••••</p>
                    </div>
                    <div>
                        <p className="text-sm text-muted-foreground">Environment</p>
                        <Badge variant={isTestKey ? 'outline' : 'default'}>
                            {isTestKey ? 'Test' : 'Live'}
                        </Badge>
                    </div>
                </div>
            </CardContent>
        </Card>
    )
}

export const MollieProcessorDetailsPage = ({ processor }: MollieProcessorDetailsPageProps) => {
    return (
        <>
            <ProcessorHeader type="mollie" processor={processor} />
            <ProcessorOverviewCard processor={processor} />
            <ProcessorMetricsCard processor={processor} />
            <MollieConfigurationCard processor={processor} />
            <ProcessorPaymentMethodsCard processor={processor} />
        </>
    )
}
